// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1,
h2,
h3,
h4,
h5,
p {
    /* font-family: ocr-a-std, monospace; */
    font-family: monospace;
    font-weight: 400;
    font-style: normal;
    color: white;
    /* mobile friendly font size */
    font-size: 16px;
}

/* if on mobile */
@media only screen and (max-width: 768px) {

    h1,
    h2,
    h3,
    h4,
    h5,
    p {
        font-size: 10px;
    }
}

br {
    padding-top: 8px;
    padding-bottom: 8px;
    height: 16px;
}

.loading::after {
    display: inline-block;
    animation: dotty steps(1, end) 1s infinite;
    content: '';
}

@keyframes dotty {
    0% {
        content: '   ';
    }

    25% {
        content: '. ';
    }

    50% {
        content: '.. ';
    }

    75% {
        content: '...';
    }

    100% {
        content: '   ';
    }
}

.blinking-cursor {
    background-color: #fff;
    width: 0.8em;
    height: 0.15em;
    -webkit-animation: 0.65s blink step-end infinite;
    -moz-animation: 0.65s blink step-end infinite;
    -ms-animation: 0.65s blink step-end infinite;
    -o-animation: 0.65s blink step-end infinite;
    animation: 0.65s blink step-end infinite;
}

@keyframes blink {

    from,
    to {
        background-color: transparent;
    }

    50% {
        background-color: white;
    }
}

@-moz-keyframes blink {

    from,
    to {
        background-color: transparent;
    }

    50% {
        background-color: white;
    }
}

@-webkit-keyframes blink {

    from,
    to {
        background-color: transparent;
    }

    50% {
        background-color: white;
    }
}

@-ms-keyframes blink {

    from,
    to {
        background-color: transparent;
    }

    50% {
        background-color: white;
    }
}

@-o-keyframes blink {

    from,
    to {
        background-color: transparent;
    }

    50% {
        background-color: white;
    }
}

.bios-start-button {
    background-color: #000;
    border: 4px solid #fff;
    border-width: 4px 3px 4px 3px;
}

.bios-start-button p {
    box-sizing: border-box;
    padding: 8px;
}

.bios-start-button:hover p {
    background-color: #fff;
    cursor: pointer;
    color: #000;
}

.loading-screen-header {
    padding: 48px;
}

.loading-screen-body {
    padding-left: 48px;
    padding-right: 48px;
}

.loading-screen-footer {
    padding: 48px;
    padding-bottom: 64px;
}

.info-wrapper {
    top: 64px;
    left: 64px;
}

/* if on mobile make all loading screen elements have a padding of 16 */
@media only screen and (max-width: 768px) {
    .loading-screen-header {
        padding: 16px;
    }

    .info-wrapper {
        top: 16px;
        left: 16px;
    }

    .blinking-cursor {
        background-color: #fff;
        width: 0.4em;
        height: 0.08em;
        -webkit-animation: 0.65s blink step-end infinite;
        -moz-animation: 0.65s blink step-end infinite;
        -ms-animation: 0.65s blink step-end infinite;
        -o-animation: 0.65s blink step-end infinite;
        animation: 0.65s blink step-end infinite;
    }

    .loading-screen-body {
        padding-left: 16px;
        padding-right: 16px;
    }

    .loading-screen-footer {
        padding: 16px;
        padding-bottom: 32px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Application/UI/style.css"],"names":[],"mappings":"AAAA;;;;;;IAMI,uCAAuC;IACvC,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,8BAA8B;IAC9B,eAAe;AACnB;;AAEA,iBAAiB;AACjB;;IAEI;;;;;;QAMI,eAAe;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,0CAA0C;IAC1C,WAAW;AACf;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,cAAc;IACd,gDAAgD;IAChD,6CAA6C;IAC7C,4CAA4C;IAC5C,2CAA2C;IAC3C,wCAAwC;AAC5C;;AAEA;;IAEI;;QAEI,6BAA6B;IACjC;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;;IAEI;;QAEI,6BAA6B;IACjC;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;;IAEI;;QAEI,6BAA6B;IACjC;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;;IAEI;;QAEI,6BAA6B;IACjC;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;;IAEI;;QAEI,6BAA6B;IACjC;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA,uEAAuE;AACvE;IACI;QACI,aAAa;IACjB;;IAEA;QACI,SAAS;QACT,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,YAAY;QACZ,cAAc;QACd,gDAAgD;QAChD,6CAA6C;QAC7C,4CAA4C;QAC5C,2CAA2C;QAC3C,wCAAwC;IAC5C;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,oBAAoB;IACxB;AACJ","sourcesContent":["h1,\nh2,\nh3,\nh4,\nh5,\np {\n    /* font-family: ocr-a-std, monospace; */\n    font-family: monospace;\n    font-weight: 400;\n    font-style: normal;\n    color: white;\n    /* mobile friendly font size */\n    font-size: 16px;\n}\n\n/* if on mobile */\n@media only screen and (max-width: 768px) {\n\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    p {\n        font-size: 10px;\n    }\n}\n\nbr {\n    padding-top: 8px;\n    padding-bottom: 8px;\n    height: 16px;\n}\n\n.loading::after {\n    display: inline-block;\n    animation: dotty steps(1, end) 1s infinite;\n    content: '';\n}\n\n@keyframes dotty {\n    0% {\n        content: '   ';\n    }\n\n    25% {\n        content: '. ';\n    }\n\n    50% {\n        content: '.. ';\n    }\n\n    75% {\n        content: '...';\n    }\n\n    100% {\n        content: '   ';\n    }\n}\n\n.blinking-cursor {\n    background-color: #fff;\n    width: 0.8em;\n    height: 0.15em;\n    -webkit-animation: 0.65s blink step-end infinite;\n    -moz-animation: 0.65s blink step-end infinite;\n    -ms-animation: 0.65s blink step-end infinite;\n    -o-animation: 0.65s blink step-end infinite;\n    animation: 0.65s blink step-end infinite;\n}\n\n@keyframes blink {\n\n    from,\n    to {\n        background-color: transparent;\n    }\n\n    50% {\n        background-color: white;\n    }\n}\n\n@-moz-keyframes blink {\n\n    from,\n    to {\n        background-color: transparent;\n    }\n\n    50% {\n        background-color: white;\n    }\n}\n\n@-webkit-keyframes blink {\n\n    from,\n    to {\n        background-color: transparent;\n    }\n\n    50% {\n        background-color: white;\n    }\n}\n\n@-ms-keyframes blink {\n\n    from,\n    to {\n        background-color: transparent;\n    }\n\n    50% {\n        background-color: white;\n    }\n}\n\n@-o-keyframes blink {\n\n    from,\n    to {\n        background-color: transparent;\n    }\n\n    50% {\n        background-color: white;\n    }\n}\n\n.bios-start-button {\n    background-color: #000;\n    border: 4px solid #fff;\n    border-width: 4px 3px 4px 3px;\n}\n\n.bios-start-button p {\n    box-sizing: border-box;\n    padding: 8px;\n}\n\n.bios-start-button:hover p {\n    background-color: #fff;\n    cursor: pointer;\n    color: #000;\n}\n\n.loading-screen-header {\n    padding: 48px;\n}\n\n.loading-screen-body {\n    padding-left: 48px;\n    padding-right: 48px;\n}\n\n.loading-screen-footer {\n    padding: 48px;\n    padding-bottom: 64px;\n}\n\n.info-wrapper {\n    top: 64px;\n    left: 64px;\n}\n\n/* if on mobile make all loading screen elements have a padding of 16 */\n@media only screen and (max-width: 768px) {\n    .loading-screen-header {\n        padding: 16px;\n    }\n\n    .info-wrapper {\n        top: 16px;\n        left: 16px;\n    }\n\n    .blinking-cursor {\n        background-color: #fff;\n        width: 0.4em;\n        height: 0.08em;\n        -webkit-animation: 0.65s blink step-end infinite;\n        -moz-animation: 0.65s blink step-end infinite;\n        -ms-animation: 0.65s blink step-end infinite;\n        -o-animation: 0.65s blink step-end infinite;\n        animation: 0.65s blink step-end infinite;\n    }\n\n    .loading-screen-body {\n        padding-left: 16px;\n        padding-right: 16px;\n    }\n\n    .loading-screen-footer {\n        padding: 16px;\n        padding-bottom: 32px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
